import React, { useState } from "react";
import { Button, Form, Input, notification, Row, Col } from "antd";
import { MaskedInput } from "antd-mask-input";
import { useAuth } from "context/providers/auth";
import { handleErrors } from "helpers/api";

import {
  name_with_numbers_regexp,
  name_regexp,
  nip_regexp,
  password_regexp,
} from "helpers/regexp";
import AuthLayout from "components/AuthLayout";
import { Link } from "react-router-dom";

const SignUp = () => {
  const [is_loading, setLoading] = useState(false);
  const { handleRegister } = useAuth();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      await handleRegister(values);
    } catch (error) {
      notification.error({ message: handleErrors(error) });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Rejestracja">
      <div className="auth-page__form">
        <Form
          name="basic"
          initialValues={{
            company_name: "",
            company_nip: "",
            first_name: "",
            last_name: "",
            phone: "",
            email: "",
            password: "",
            password_confirmation: "",
          }}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Row gutter={[12, 12]}>
            <Col xs={24} md={24} lg={12} xl={12}>
              <Form.Item
                label="Nazwa firmy"
                name="company_name"
                required
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Nazwa firmy jest wymagana!",
                  },
                  {
                    pattern: name_with_numbers_regexp,
                    message: "Pole zawiera niedozolone znaki!",
                  },
                ]}
              >
                <Input placeholder="Nazwa firmy" maxLength={128} />
              </Form.Item>
            </Col>
            <Col xs={24} md={24} lg={12} xl={12}>
              <Form.Item
                label="NIP"
                name="company_nip"
                required
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Nip firmy jest wymagany!",
                  },
                  {
                    pattern: nip_regexp,
                    message: "Niepoprawny NIP",
                  },
                ]}
              >
                <MaskedInput mask="0000000000" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[12, 12]}>
            <Col xs={24} md={24} lg={12} xl={12}>
              <Form.Item
                label="Imię"
                name="first_name"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Imię jest wymagane!",
                  },
                  {
                    pattern: name_regexp,
                    message: "Pole zawiera niedozwolone znaki!!",
                  },
                ]}
              >
                <Input placeholder="Imię" maxLength={60} />
              </Form.Item>
            </Col>
            <Col xs={24} md={24} lg={12} xl={12}>
              <Form.Item
                label="Nazwisko"
                name="last_name"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Nazwisko jest wymagane!",
                  },
                  {
                    pattern: name_regexp,
                    message: "Pole zawiera niedozwolone znaki!!",
                  },
                ]}
              >
                <Input placeholder="Nazwisko" maxLength={60} />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label="E-mail"
            name="email"
            hasFeedback
            rules={[
              {
                type: "email",
                message: "Niepoprawny e-mail",
              },
              {
                required: true,
                message: "Email jest wymagany!",
              },
              {
                max: 128,
                message: "Przekroczono maksymalną ilość znaków!",
              },
            ]}
          >
            <Input placeholder="E-mail" maxLength={128} />
          </Form.Item>
          <Row gutter={[12, 12]}>
            <Col xs={24} md={24} lg={12} xl={12}>
              <Form.Item
                label="Telefon"
                name="phone"
                required
                hasFeedback
                rules={[
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(
                          new Error("Numer telefonu wymagany!")
                        );
                      }
                      if (value.includes("_")) {
                        return Promise.reject(
                          new Error("Numer telefonu niepoprawny!")
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <MaskedInput mask="000000000" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[12, 12]}>
            <Col xs={24} md={24} lg={12} xl={12}>
              <Form.Item
                label="Hasło"
                name="password"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Hasło jest wymagane!",
                  },
                  {
                    max: 128,
                    message: "Przekroczono maksymalną ilość znaków!",
                  },
                  {
                    min: 8,
                    message: "Hasło musi mieć co najmniej 8 znaków!",
                  },
                  {
                    pattern: password_regexp,
                    message:
                      "Hasło musi zawierać przynajmniej jedną dużą literę, jedną cyfrę i jeden znak specjalny!",
                  },
                ]}
              >
                <Input.Password maxLength={128} />
              </Form.Item>
            </Col>
            <Col xs={24} md={24} lg={12} xl={12}>
              <Form.Item
                label="Potwierdź hasło"
                name="password_confirmation"
                dependencies={["password"]}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Potwierdzenie hasła jest wymagane!",
                  },

                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Hasła muszą być takie same!")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password maxLength={128} />
              </Form.Item>
            </Col>
          </Row>
          <Button
            block
            loading={is_loading}
            disabled={is_loading}
            size="large"
            type="primary"
            htmlType="submit"
          >
            Zarejestruj się
          </Button>
        </Form>
      </div>
      <div className="auth-page__links">
        <Link to="/">Wróć do logowania</Link>
      </div>
    </AuthLayout>
  );
};

export default SignUp;
